export const getContentWithoutHTML = (value: string) =>
  value.replace(/<\/?[^>]+>/g, '');
